import { Component, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrl: './confirmation.component.scss'
})
export class ConfirmationComponent {

  modalData:any;
  constructor(
    public dialogRef:MatDialogRef<ConfirmationComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data:any
  ){
    this.modalData = data;
  }

  confirmClick(){
    this.dialogRef.close('Yes');
  }

  cancelClick(){
    this.dialogRef.close();
  }

}
